export default {
  appOrchardAppId: process.env.REACT_APP_SSO_EPIC_DISNEY_APP_ORCHARD_ID,
  redirectBackToKindbodyUrl: () => `${window.location.origin}/login-sso/epic-disney`,
  epicUrl: process.env.REACT_APP_SSO_EPIC_DISNEY_EPIC_URL
};
